"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const BlockButton_1 = __importDefault(require("../Utilities/BlockButton"));
class CarouselIndicator extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onSlideClick = () => {
            console.log('slide clicked');
            this.props.goToSlide(this.props.slideNumber);
        };
    }
    render() {
        const { active, offset } = this.props;
        return (react_1.default.createElement(BlockButton_1.default, { as: 'li', style: Object.assign(Object.assign({}, offset), { textIndent: '0', overflow: 'hidden' }), className: active ? 'active' : '', onClick: this.onSlideClick }, this.props.children));
    }
}
exports.default = CarouselIndicator;
CarouselIndicator.propTypes = {
    active: prop_types_1.default.bool,
    children: prop_types_1.default.node,
    goToSlide: prop_types_1.default.func,
    slideNumber: prop_types_1.default.number,
    offset: prop_types_1.default.objectOf(prop_types_1.default.number),
};
